export const syncMissingParticipantsFromStatusHistory = (
  existingParticipants = [],
  statusHistory = []
) => {
  const existingRefs = new Set();
  existingParticipants.forEach((participant) => {
    if (participant?.individual?.reference) {
      existingRefs.add(participant.individual.reference);
    }
  });

  const missingParticipants = [];
  const practitionersFromHistory = new Map();
  
  statusHistory.forEach((statusEntry) => {
    if (statusEntry?.actor?.reference && statusEntry?.actor?.type === "Practitioner") {
      const practitionerRef = statusEntry.actor.reference;
      
      if (!existingRefs.has(practitionerRef)) {
        const entryStart = statusEntry.period?.start || new Date().toISOString();
        
        if (!practitionersFromHistory.has(practitionerRef)) {
          practitionersFromHistory.set(practitionerRef, {
            individual: {
              reference: practitionerRef,
              display: statusEntry.actor.display,
              type: "Practitioner"
            },
            period: {
              start: entryStart,
              end: statusEntry.period?.end || null
            }
          });
        } else {
          const existing = practitionersFromHistory.get(practitionerRef);
          const existingStart = existing.period?.start;
          if (!existingStart || new Date(entryStart) < new Date(existingStart)) {
            existing.period.start = entryStart;
          }
        }
      }
    }
  });

  return [...existingParticipants, ...Array.from(practitionersFromHistory.values())];
};

